import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from 'src/app/servicios/api/api.service';
import { AppServiceService } from 'src/app/servicios/AppService.service';
import { RespuestaCuadrosSalidaChvDto } from '../../modelos/cuadrossalida/RespuestaCuadrosSalidaChvDto'
import * as XLSX from 'xlsx';
import { CuadrossalidaService } from 'src/app/servicios/cuadrossalida/cuadrossalida.service';
import { CuadroSalidaA1Dto } from 'src/app/modelos/cuadrossalida/CuadroSalidaA1Dto';
import { AnalisisService } from 'src/app/servicios/analisis/analisis.service';

@Component({
  selector: 'app-cuadrosSalidaChv',
  templateUrl: './cuadrosSalidaChv.component.html',
  styleUrls: ['./cuadrosSalidaChv.component.css']
})
export class CuadrosSalidaChvComponent implements OnInit {

  botones: Boolean = true;
  cuadrosSalida: RespuestaCuadrosSalidaChvDto = new RespuestaCuadrosSalidaChvDto();
  trimestreActual : any = "I";
  anioActual : any = "I";
  nombreDescarga : any = "";
  nombreDescarga1 : any = "";
  stringBase64 : any = "";
  botonDescarga : Boolean = false;

  @ViewChild('openmodalcargando') openmodalcargando: ElementRef;
  @ViewChild('closemodacargando') closemodacargando: ElementRef;

  constructor(
    private api:ApiService,
    private router:Router,
    private toastr: ToastrService,
    private appService:AppServiceService,
    private cuadrosSalidaService:CuadrossalidaService,
    private analisisService:AnalisisService
  ) { }

  ngOnInit() {
    this.botones = false;
    this.analisisService.consultarPeriodoActivoCHV().subscribe(Result=>{
      this.trimestreActual = Number(Result.consecutivoPeriodo)
      this.anioActual = Number(Result.anio);
    });
  }

  RegresarCuadrosSalida(){
    this.router.navigate(['CuadrosSalida']);
  }

  iniciarDescarga(nombre, cuadro){
    this.botonDescarga = false;
    this.nombreDescarga1 = nombre;
    this.nombreDescarga = nombre + ".xlsx";
    this.openmodalcargando.nativeElement.click();
    this.cuadrosSalidaService.getCuadrosSalidaChv(cuadro).subscribe(resultado=>{
      if(resultado != undefined || resultado != null) {
        this.stringBase64 = resultado.data;
        this.botonDescarga = true;
      } else{
        console.log("error " + resultado)
      }
    });
  }

  descargarArchivo() {
    if (this.stringBase64) {
      const blob = this.base64toBlob(this.stringBase64);
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = this.nombreDescarga;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } else {
      console.error('No hay datos para descargar');
    }
    this.closemodacargando.nativeElement.click();
    this.botonDescarga = false;
    this.nombreDescarga = "";
    this.stringBase64 = "";
  }

  base64toBlob(base64Data: string): Blob {
    const sliceSize = 512;
    const byteCharacters = atob(base64Data);
    const byteArrays: Uint8Array[] = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  }

}
